<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Admin' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>学校列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
      <el-row class="form-row">
        <el-text style="width:100px; text-align: right;">学校：</el-text>
        <el-col :span="21">
          <el-input placeholder="请输入学校" style="width:400px;" v-model="subData.name" @blur="onBlur"></el-input>
        </el-col>
      </el-row>
      <el-row class="form-row">
        <el-text style="width:100px; text-align: right;">校徽：</el-text>
        <el-col :span="4">
          <el-upload
            class="avatar-uploader"
            :action="uploadUrl"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="subData.icon" :src="subData.icon" style="height:150px;" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon" style="font-size:60px; font-style:normal;">+</i>
          </el-upload>
        </el-col>
      </el-row>
      <el-row class="form-row">
        <el-text style="width:100px; text-align: right;">位置：</el-text>
        <el-col :span="21">
           <map-contain ref="mapContain"></map-contain>
        </el-col>
      </el-row>

      <el-row class="bt" style="padding:15px 0; padding-left: 100px;">
        <el-button type="primary" @click="submitEvent">确定</el-button>
        <el-button plain type="primary" @click="backEvent">返回</el-button>
      </el-row>
    </el-card>
  </div>
</template>

  
<script>
export default {
  data() {
    return {
      id: this.$route.query.id?this.$route.query.id:0,
      uploadUrl: '',
      subData:{
        name: '',
        icon: '',
        locations: []
      }
    }
  },
  mounted:function(){
    this.uploadUrl = this.API_URL + '/file/upload'
    if(this.id>0){
      this.getData()
    }else{
      this.$refs.mapContain.initMap()
    }
  },
  methods: {
    backEvent(){
        this.$router.go(-1)
    },
    handleAvatarSuccess(res, file) {
      this.subData.icon = res.data;
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    onBlur(){
      console.log("blur")
      this.$refs.mapContain.searchLocation(this.name)
    },
    getData(){
      var ths = this
      ths.$get('/Schools/queryById?id='+ths.id)
      .then(function (res) { 
          if(res.success){
            ths.subData = res.data
            ths.$refs.mapContain.setPoints(res.data.locations)
            ths.$refs.mapContain.initMap()
          }
      })
      .catch(function (err) {
        console.log(err)
      })    
    },
    submitEvent() {
      const ths = this
      var points = this.$refs.mapContain.getPoints()
      var newPoints = []
      for(var i =0 ; i < points.length; i++){
        var obj = points[i]
        newPoints.push({
          lng: obj.lng,
          lat: obj.lat
        })
      }
      ths.subData.locations = newPoints
      ths.$post('/Schools/edit?', ths.subData)
        .then(function (res) { 
            alert(res.msg)
            if(res.success){
              ths.$router.push("/Admin/SchoolsList")
            }
        })
        .catch(function (err) {
          console.log(err)
        })      
      },
   },
   watch:{
    name(newVal, oldVal){
    }
   }
}

</script>

<style>
.form-row{
  padding:15px 0; 
}
</style>